import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';

import { AppStateContext } from '../AppStateContext';

import { AiFillInstagram, AiFillMail, AiFillPhone, AiOutlineWhatsApp } from 'react-icons/ai'
import { ImLocation } from 'react-icons/im'

const Footer = () => {

    const navigate = useNavigate();
    const { language, setLanguage } = useContext(AppStateContext);

    const translations = {
        tr: {
            footertext1: 'Yeşim Alkan Kliniği, diş ve ağız sağlığı tedavilerine odaklanan özelleşmiş bir tıbbi hizmet girişimidir. Mükemmelliği başarma konusundaki bağlılığımız, dünya genelindeki hastalarımızdan olumlu geri bildirimler almamıza neden olmuştur.',
            footertext2: 'MENÜ',
            footertext3: 'Ana Sayfa',
            footertext4: 'Hakkımızda',
            footertext5: 'Tedaviler',
            footertext6: 'Blog',
            footertext7: 'İletişim',
            footertext8: 'Sorun',
            footertext9: 'POPÜLER TEDAVİLER',
            footertext10: 'Diş Beyazlatma',
            footertext11: 'Diş Kaplamaları',
            footertext12: 'Diş İmplantları',
            footertext13: 'RANDEVU HATTI',
            footertext14: 'WHATSAPP RANDEVU HATTI',
            footertext15: 'İLETİŞİM',
        },
        en: {
            footertext1: 'Yeşim Alkan Clinic is a specialized medical services venture focusing on dental and oral health treatments. Our dedication to achieving excellence has garnered positive feedback from our patients around the world.',
            footertext2: 'MENU',
            footertext3: 'Home',
            footertext4: 'About',
            footertext5: 'Treatments',
            footertext6: 'Blog',
            footertext7: 'Contact',
            footertext8: 'Ask',
            footertext9: 'POPULAR TREATMENTS',
            footertext10: 'Teeth Whitening',
            footertext11: 'Dental Veneers',
            footertext12: 'Dental Implants',
            footertext13: 'APPOINTMENT LINE',
            footertext14: 'WHATSAPP APPOINTMENT LINE',
            footertext15: 'CONTACT',
        },
        it: {
            footertext1: 'Yeşim Alkan Clinic es una empresa especializada en servicios médicos enfocados en tratamientos dentales y de salud bucal. Nuestra dedicación para lograr la excelencia ha recibido comentarios positivos de nuestros pacientes en todo el mundo.',
            footertext2: 'MENÚ',
            footertext3: 'Inicio',
            footertext4: 'Acerca de',
            footertext5: 'Tratamientos',
            footertext6: 'Blog',
            footertext7: 'Contacto',
            footertext8: 'Preguntar',
            footertext9: 'TRATAMIENTOS POPULARES',
            footertext10: 'Blanqueamiento Dental',
            footertext11: 'Carillas Dentales',
            footertext12: 'Implantes Dentales',
            footertext13: 'LÍNEA DE CITA',
            footertext14: 'LÍNEA DE CITA DE WHATSAPP',
            footertext15: 'CONTACTO',
        },
    };

    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    };

    const handleNavigation = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    }

    const openLink = (url) => {
        window.open(
            url,
            '_blank'
        );
    }

    const handleMailSend = () => {
        const emailAddress = 'info@dtyesimalkan.com';
        window.location.href = `mailto:${emailAddress}`;
    }

    const handlePhoneCall = () => {
        const phoneNumber = '+90 533 353 64 06';
        window.location.href = `tel:${phoneNumber}`;
    }

    return (
        <div className='bg-[#05161A] w-full py-10'>
            <div className='max-w-screen-xl w-full flex flex-col md:flex-row m-auto'>
                <div className='flex flex-col p-5 w-full md:w-1/4 gap-5'>
                    <div style={{ fontFamily: 'Righteous' }} className='text-4xl text-[#0F969C]'>Dt. Yeşim Alkan</div>
                    <div className='text-white'>{getText('footertext1')}</div>
                </div>

                <div className='flex flex-col p-5 w-full md:w-1/4 md:items-center gap-2'>
                    <div className='text-lg font-bold text-white'>{getText('footertext2')}</div>
                    <div onClick={() => handleNavigation('/')} className='text-lg text-slate-500 cursor-pointer '>{getText('footertext3')}</div>
                    <div onClick={() => handleNavigation('/about')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext4')}</div>
                    <div onClick={() => handleNavigation('/treatments')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext5')}</div>
                    {/* <div onClick={() => handleNavigation('/')} className='text-lg text-slate-500'>{getText('footertext6')}</div> */}
                    <div onClick={() => handleNavigation('/contact')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext7')}</div>
                    <div onClick={() => openLink('https://api.whatsapp.com/send?phone=905333536406')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext8')}</div>
                </div>
                <div className='flex flex-col p-5 w-full md:w-1/4 gap-2'>
                    <div className='text-lg font-bold text-white'>{getText('footertext9')}</div>
                    <div onClick={() => handleNavigation('/treatment/bleaching')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext10')}</div>
                    <div onClick={() => handleNavigation('/treatment/lamine')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext11')}</div>
                    <div onClick={() => handleNavigation('/treatment/implant')} className='text-lg text-slate-500 cursor-pointer'>{getText('footertext12')}</div>
                </div>

                <div className='flex flex-col p-5 w-full md:w-1/4 gap-5'>
                    <div className='flex flex-col gap-2'>
                        <div className='font-bold text-white'>{getText('footertext13')}</div>
                        <div className='flex flex-row gap-2 items-center'>
                            <AiFillPhone className='text-[#6DA5C0]' size={20} />
                            <div className='text-slate-500'>+90 (850) 532 53 38</div>
                        </div>

                    </div>

                    <div className='border-2 border-slate-200 w-full rounded-2xl'></div>

                    <div className='flex flex-col gap-2'>
                        <div className='font-bold text-white'>{getText('footertext14')}</div>
                        <div className='flex flex-row gap-2 items-center'>
                            <AiOutlineWhatsApp className='text-[#6DA5C0]' size={20} />
                            <div className='text-slate-500'>+90 (850) 532 53 38</div>
                        </div>

                    </div>

                    <div className='border-2 border-slate-200 w-full rounded-2xl'></div>

                    <div className='flex flex-col gap-2'>
                        <div className='font-bold text-white'> {getText('footertext15')}</div>
                        <div className='flex flex-row gap-5 text-[#6DA5C0]'>
                            <AiFillPhone onClick={handlePhoneCall} size={20} className='cursor-pointer ' />
                            <ImLocation onClick={() => openLink('https://goo.gl/maps/ZEinpNRcKtNM74GA7')} size={20} className='cursor-pointer ' />
                            <AiFillMail onClick={handleMailSend} size={20} className='cursor-pointer' />
                            <AiFillInstagram onClick={() => openLink('https://www.instagram.com/dishekimi_yesim_alkan/')} size={20} className='cursor-pointer ' />
                        </div>
                    </div>

                </div>
            </div>
            <div className='text-[#6DA5C0] text-end max-w-screen-xl m-auto px-5'>Developed By 3NCOR3</div>

        </div>
    )
}

export default Footer